$ = window.jQuery;

// cycle the images in suppliers
export default (obj, not) => {
	if (obj.length) {
		let cls = Array.from(obj.get(0).classList).pop();
		cls += (cls.includes("__") ? "-" : "__") + "item";
		obj.each(function (n) {
			const hide = cls + "--hide",
				base = $("." + cls + ":not(." + hide + ")" + (not ? ":not(" + not + ")" : ""), this),
				len = base.length,
				items = $("." + hide, this).css("position", "absolute"),
				total = items.length + base.length;
			items.each(function (i) {
				const copy = base.eq(i % len),
					$this = $(this),
					func = () => {
						$this.removeClass(hide);
						setTimeout(() => $this.addClass(hide), 5000);
					};
				$this.offset(copy.offset()).width(copy.width()).height(copy.height());
				setTimeout(() => {
					func();
					setInterval(func, 5000 * Math.ceil(total / len));
				}, (5000 * Math.floor(i / len)) + ((i % len + n * len) * 100));
			});
		});
	}
};